import { APP_CAN_APPS_V3, APP_CAN_TRACK } from 'constants/appNames';
import assignType from './assignType';
import { modifyCanAppsV1Path, modifyCanAppsV3Path } from './modifyCanAppsPaths';
import { AppTypes } from 'constants/appTypes';

/**
 * @function updateTabTypeAndURL
 * @param { object } apps
 * @returns { object }
 */
function updateTabTypeAndURL(tab) {
	let newTab = Object.assign({}, tab);

	if (newTab.url === '' || newTab.url === '/') {
		newTab.url = window.location.origin;
		newTab.type = AppTypes.Regular;
	} else {
		const paths = newTab.url.split('/');

		if (paths[1] === AppTypes.CanAppsV3) {
			newTab.type = AppTypes.CanAppsV3;
		} else if (paths[1] === AppTypes.CanTrack) {
			newTab.type = AppTypes.CanTrack;
		} else {
			newTab.type = AppTypes.CanAppsV1;
		}

		if (paths[1] === AppTypes.CanAppsV3) {
			newTab.url = modifyCanAppsV3Path(paths);
		} else if (paths[1] !== AppTypes.CanTrack) {
			newTab.url = modifyCanAppsV1Path(paths);
		}
	}
	return newTab;
}

/**
 * @async
 * @function addTabType
 * @param { array } apps
 * @returns { Promise<Array> }
 */
function addTabType(apps) {
	for (let i = 0; i < apps.length; i++) {
		for (let j = 0; j < apps[i].tabs.length; j++) {
			if (apps[i].tabs[j].url !== 'Sub-menu') {
				const newTabObj = updateTabTypeAndURL(apps[i].tabs[j]);
				apps[i].tabs[j] = newTabObj;
			} else if (apps[i].tabs[j].url === 'Sub-menu') {
				/**
				 * @todo: clear code...
				 */
				if (apps[i].tabs[j].subtabs === undefined) {
					apps[i].tabs[j]['subtabs'] = [];
				} else {
					for (let k = 0; k < apps[i].tabs[j]?.subtabs.length; k++) {
						const paths = apps[i].tabs[j]?.subtabs[k].url.split('/');
						const name = assignType(paths[1]);
						apps[i].tabs[j].subtabs[k].type = name;
						if (name === APP_CAN_APPS_V3) {
							apps[i].tabs[j].subtabs[k].url = modifyCanAppsV3Path(paths);
						} else if (name !== APP_CAN_TRACK) {
							apps[i].tabs[j].subtabs[k].url = modifyCanAppsV1Path(paths);
						}
					}
				}
			}
		}
	}
	return apps;
}

export default addTabType;
